import { CreateControllerFn } from '@wix/yoshi-flow-editor';
import { createForumAppController } from '../../app/controllers/createForumAppController';

const createController: CreateControllerFn = async ({ controllerConfig, flowAPI }) => {
  return createForumAppController(controllerConfig, flowAPI);
};

export default createController;
